import { inject, Injectable } from '@angular/core';
import { UserSettingDto, UserSettingsClient } from './api.service';
import { first, map, Observable } from 'rxjs';
import { UserSettingsStore } from 'app/store/user-setting.store';

@Injectable({
	providedIn: 'root',
})
export class UserSettingsService {
	userSettingsStore = inject(UserSettingsStore);
	private _userSettingsClient = inject(UserSettingsClient);

	constructor() {}

	get(): Observable<UserSettingDto[]> {
		return this._userSettingsClient.getByUser().pipe(
			map((settings) => {
				this.userSettingsStore.initializeUserSettings(settings);

				return settings;
			})
		);
	}

	/**
	 * Update the user settings by key and value.
	 *
	 * @param key
	 * @param value
	 */
	setByKeyValue(key: string, value: string) {
		this._userSettingsClient
			.setByKey(key, value)
			.pipe(first())
			.subscribe({
				next: () => {
					this.userSettingsStore.updateUserSetting(key, value);
				},
				error: (error) => {},
			});
	}
}
